import React, { Component } from 'react';

import btwb from '../assets/btwb-114x114.png';

class Header extends Component {
  constructor(props) {
    super(props)

    this.state = {

    }
  }

  componentDidUpdate() {
    if(!this.props.gym) return;
    
    if(this.state.date === this.props.gym.updated_at) return;
    this.setState({
      date: this.props.gym.updated_at,
      code: this.props.gym.invite_code,
      image: this.props.gym.image,
      gymName: this.props.gym.display_name
    }); 
  }

  render() {
    return(
      <div>
        <div
          className="absolute top-1 left-1 z-2">
          <h2 className="ml4 mt3 ph2 white transformY--50 t-black">PR BOARD ⚡</h2>
        </div>

        <div
          className="absolute top-1 right-30 z-2">
          <h3 className="mr4 mt3 ph2 white roboto transformY--50 t-black"><img className="br-100 mt3" width="40" height="40" src={this.state.image} /></h3>
        </div>

        <div
          className="absolute top-1 right-1 z-2">
          <h3 className="mr4 mt3 ph2 white roboto transformY--50 t-black"><img className="br-100 mt3" width="40" height="40" src={btwb} /></h3>
        </div>
      </div>
    )
  }
}

export default Header;


// WEBPACK FOOTER //
// ./src/components/Header.js